import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { Inbox, MailWarning, Flame, TrendingUp, Eye } from "lucide-react";
import { adminStats } from "@/lib/api";

const Card = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white border border-border rounded-xl p-6">
    <div className="flex items-center justify-between">
      <span className={`flex h-11 w-11 items-center justify-center rounded-full ${color}`}><Icon className="h-5 w-5" /></span>
      <span className="text-3xl font-semibold text-secondary">{value ?? "—"}</span>
    </div>
    <p className="mt-3 text-sm text-muted-foreground">{label}</p>
  </div>
);

const Dashboard = () => {
  const { data: stats } = useQuery({ queryKey: ["admin-stats"], queryFn: adminStats });
  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-4xl text-secondary">Dashboard</h1>
      <p className="text-muted-foreground mt-1">Overview of enquiries and content.</p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <Card icon={Eye} label="Website Visits" value={stats?.total_visits} color="bg-blue-500/10 text-blue-600" />
        <Card icon={Inbox} label="Total Enquiries" value={stats?.total_enquiries} color="bg-primary/10 text-primary" />
        <Card icon={MailWarning} label="New (unactioned)" value={stats?.new_enquiries} color="bg-secondary/10 text-secondary" />
        <Card icon={Flame} label="Total Poojas" value={stats?.total_poojas} color="bg-gold/20 text-secondary" />
      </div>

      <div className="mt-8 bg-white border border-border rounded-xl p-6">
        <h2 className="flex items-center gap-2 font-heading text-2xl text-secondary"><TrendingUp className="h-5 w-5 text-primary" /> Top Poojas by Enquiries</h2>
        {stats?.top_poojas?.length ? (
          <ul className="mt-4 space-y-3">
            {stats.top_poojas.map((t) => (
              <li key={t.name} className="flex items-center justify-between border-b border-border pb-2 last:border-0">
                <span className="text-secondary font-medium">{t.name}</span>
                <span className="text-sm bg-primary/10 text-primary rounded-full px-3 py-0.5 font-semibold">{t.count} enquiries</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="mt-4 text-muted-foreground text-sm">No enquiry data yet. Once devotees submit enquiries, the most-requested poojas will appear here.</p>
        )}
      </div>

      <div className="mt-6 flex gap-3">
        <Link to="/admin/enquiries" className="rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-[#CC5204]">View Enquiries</Link>
        <Link to="/admin/poojas" className="rounded-md border border-border bg-white px-5 py-2.5 text-sm font-semibold text-secondary hover:border-primary">Manage Poojas</Link>
      </div>
    </div>
  );
};

export default Dashboard;
